import { createContext, useContext } from "react"

// Dates
import { DateTime } from "@/lib/dates"

type Context = {
	date: Date
	setDate(graphInterval: Context["date"]): void
	sunrise: number
	sunset: number
	isToday: boolean
	isBeforeSunrise: boolean
	maximumDate: DateTime
	minimumDate: DateTime
}

export const AreaGraphContext = createContext<Context>(null!)

export function useAreaGraphContext() {
	const context = useContext(AreaGraphContext)

	if (!context) {
		throw new Error(
			"AreaGraphContext must be used within a AreaGraphProvider",
		)
	}

	return context
}
